import TimeUtils from './TimeUtils';

export default class ShotChangeUtils {
  /**
   * 從原始資料取得 Shot Array
   * @param {*} _orgTxt 原始資料
   * @returns
   */
  static getShotArrayFromTxt(_orgTxt) {
    const ShotArr = _orgTxt.split('\n');
    var finalArray = [];

    ShotArr.forEach((shotString) => {
      if (shotString.includes('pts_time')) {
        const targetArr = shotString.split('pts_time:');
        // console.log(targetArr[1]);
        finalArray.push(targetArr[1]);
      }
    });
    return finalArray;
  }

  //取得專案Pts
  static getPtsArrayFromTxt(_orgTxt) {
    const ShotArr = _orgTxt.split('\n');
    var finalArray = [];

    ShotArr.forEach((shotString) => {
      if (shotString.includes('pts:')) {
        const targetArr = shotString.split('pts:');
        // console.log(targetArr[1]);
        finalArray.push(targetArr[1]);
      }
    });
    return finalArray;
  }

  /**
   * ShotChange 執行 ==========================================
   * */
  static runShotChange(_orgshotChangeTxt, _WaveformView) {
    if (_orgshotChangeTxt === null) {
      return;
    }

    const shotArray = ShotChangeUtils.getShotArrayFromTxt(_orgshotChangeTxt);
    const shotPTSArray = ShotChangeUtils.getPtsArrayFromTxt(_orgshotChangeTxt);

    _WaveformView.shotchangeData = shotArray;
    _WaveformView.shotchangePtsData = shotPTSArray;

    /**
     * 把所有資訊放奧
     * */
    // this.DataObjArray.addShotArray(shotArray);

    /**
     * 介面
     * */ //ShotChangeUtils
    var WaveGroup = document.getElementById('WaveGroup');

    //const currentLeft = (document.getElementById('WaveGroup').style.left).replace('px', '');

    shotArray.forEach((shotData) => {
      var finalLeft = 300 + shotData * 40;
      var orgDiv = document.createElement('div');
      orgDiv.style.position = `absolute`;
      orgDiv.style.left = `${finalLeft}px`;
      orgDiv.style.backgroundColor = `#ff762587`;
      orgDiv.style.width = `2px`;
      orgDiv.style.height = `96px`;
      orgDiv.style.zIndex = `1`;
      WaveGroup.appendChild(orgDiv);
    });
  }

  /**
   * ShotChange 從秒數轉換成 frame ==========================================
   * */
  static shotChangeToFrameArray(_shotSecondChangeArray, _videoFps) {
    let shotChange_frame_Array = _shotSecondChangeArray.map((sec, index) => {
      // return Math.round(parseFloat(_videoFps) * parseFloat(sec)) + 1;
      // return Math.round(parseFloat(_videoFps) * parseFloat(sec) * 1) / 1;

      // 新影像的時間要加上 1f
      const startSecomd = parseFloat(sec) + 1/parseFloat(_videoFps);

      return Math.round(parseFloat(_videoFps) * startSecomd) ;
      // return Math.round(parseFloat(_videoFps) * sec) ;
    });
    // console.log(_shotSecondChangeArray);
    // console.log(shotChange_frame_Array);
    return shotChange_frame_Array;
  }

  /**
   * 取出距離 (用 timeString 計算 in 的距離)
   * @description 原版的計算方式 : Math.round(_scObj.frame - inObj.frame).toFixed();
   * @param {*} _scObj
   * @param {*} inObj
   * @returns
   */
  static getDistanceByTimeString(_scObj, inObj) {
    const _scObjFrame = TimeUtils.timeString_convertTo_frame(_scObj.timeString);
    const inObjFrame = TimeUtils.timeString_convertTo_frame(inObj.timeString);

    return _scObjFrame - inObjFrame;
  }
}



// WEBPACK FOOTER //
// ./src/helper/ShotChangeUtils.js